module.exports = __webpack_public_path__ + "static/media/css.b37dbaa6.png";